import React from 'react'

//Bibliotecas
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';


//Componentes
import Button from '../components/common/Button';

//Imagenes
import una from '../assets/images/401.png';
import { CornerUpLeft } from 'react-feather';

export const Unauthorized = () => {
  //React Dom Router
  const navigate = useNavigate();
  return (
    <Container>
      <Image src={una}></Image>
      <Info>
        <Message>
          <h1>401</h1>
          <h2>No autorizado</h2>
        </Message>
        <Box>
          <span>Oops!</span>
          <span>Parece que no debes estar acá</span>
          <p>La página que estás buscando requiere de permisos que no posees.</p>
          <Button onClick={() => { navigate("/") }}><CornerUpLeft />Regresar a inicio</Button>
        </Box>
      </Info>
    </Container>
  )
}

export default Unauthorized;

const Container = styled.div`
  background: rgb(86,11,173);
  background: -moz-linear-gradient(90deg, rgba(86,11,173,1) 0%, rgba(58,12,163,1) 100%);
  background: -webkit-linear-gradient(90deg, rgba(86,11,173,1) 0%, rgba(58,12,163,1) 100%);
  background: linear-gradient(90deg, rgba(86,11,173,1) 0%, rgba(58,12,163,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#560bad",endColorstr="#3a0ca3",GradientType=1);
  display: flex;
  flex-direction: row;  
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow:hidden;
`;
const Info = styled.div`
  width:35%;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  text-align:center;
  color:var(--color-blanco);
  h1{
    font-size: 96px;
    margin-bottom:16px;
  }
  h2{
    font-size:32px;
  }
`;

const Image = styled.img`
  width:60%;
`;
const Message = styled.div`
`;
const Box = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  background-color: var(--color-blanco);
  margin:32px;
  padding:32px;
  border-radius:8px;
      
  span:first-child{ 
        font-size: 2.441rem;
        font-weight: 900;
        color: var(--color-morado-claro);
    
    }
    span:nth-child(2){
        font-size: 1.441rem;
        font-weight: 700;
        margin-bottom: 16px;
        color: var(--color-negro);
    }
    p{
        margin-bottom:32px;
        color:var(--color-negro);
    }
`;